<template>
    <div class="log-entries">
        <table>
            <tr v-for="entry in formattedEntries" :key="entry.id">
                <td>
                    <timestamp :date="entry.created"
                               :include-year="true"
                               :include-time="true"/>
                </td>
                <td>{{ entry.userEmail }}</td>
                <td>{{ entry.action }}</td>
                <td style="white-space:pre-wrap;">
                    {{ entry.text }}
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import Logging from '@/providers/Logging'

export default {
    name: 'LogEntries',
    props: {
        table: String,
        modelInstanceId: Number
    },
    data () {
        return {
            entries: []
        }
    },
    computed: {
        formattedEntries () {
            return Logging.formattedEntries(this.entries)
        }
    },
    async mounted () {
        const item = await this.$api.getItem(this, this.table, this.modelInstanceId, ['userLogs'])
        this.entries = item.userLogs
    }
}
</script>

<style lang="scss">
.log-entries {
    color: #666;

    tr:nth-child(even) {
        //background-color: #f9f9f9;
        border-top: solid 1px #e5e5e5;
    }
}

</style>